"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBasketOverviewConfig = exports.useComponentConfig = exports.ComponentConfigContext = void 0;
const react_1 = require("react");
exports.ComponentConfigContext = (0, react_1.createContext)({});
const useComponentConfig = () => (0, react_1.useContext)(exports.ComponentConfigContext);
exports.useComponentConfig = useComponentConfig;
const useBasketOverviewConfig = () => (0, exports.useComponentConfig)();
exports.useBasketOverviewConfig = useBasketOverviewConfig;
